import { BUSINESS_ADMIN_HOST } from 'api/constants';

export const CHANGE_USER_EMAIL_URL = `${BUSINESS_ADMIN_HOST}/v1/users/change-user-email`;
export const CHANGE_USER_EMAIL_LOGS_URL = `${BUSINESS_ADMIN_HOST}/v1/users/change-user-email/logs`;
